<div class="counts" *ngIf="serviceManagementCounts">
  <mat-expansion-panel class="count-panel" [hideToggle]="true">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="panel-title"
        >Service Management
        <span>{{ serviceManagementCounts.total }}</span></mat-panel-title
      >
    </mat-expansion-panel-header>
    <div class="panel-body">
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'serviceManagementCounts',
          'serviceIncomplete'
        ]"
      >
        <p class="count">Service Incomplete</p>
        <span>{{ serviceManagementCounts.serviceIncomplete }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'serviceManagementCounts',
          'serviceFinished'
        ]"
      >
        <p class="count">Service Finished</p>
        <span>{{ serviceManagementCounts.serviceFinished }}</span>
      </div>
    </div>
  </mat-expansion-panel>
</div>
